export enum PreviousProductType {
    Unknown =0,
    Halal = 1,
    Kosher = 2,
    GMP = 3
}